<template>
  <v-card class="d-flex pa-2 flex-column" outlined>
    <v-alert
      v-model="flashError"
      dense
      border="left"
      type="error"
      dismissible
      elevation="2"
    >
      {{ flashErrorMessage }}
    </v-alert>

    <aggregator-transaction-filter
      :search="search"
      v-on:clearSearchParent="clearSearch"
      v-on:getDataParent="getData"
      :loading="loading"
      type="direceMid"
      :module="'cpm'"
    />
    <TableView
      :headers="headers"
      :items="allData"
      :options.sync="options"
      :loading="loading"
      :totalData="totalData"
      :customTopActions="true"
      item-key="id"
      table-height="70vh"
      @select-row="selectRow"
    >
    <template v-slot:top>
        <table-top-vue
          :loading="loading"
          :listButton="listButton"
          v-on:getDataParent="getData"
          v-on:exportItemParent="exportItem"
          v-on:exportExcelParent="exportExcel"
          :switchCh="switchCh"
          v-on:onSwitch="handleSwitch"
        />
      </template>
      <template slot="action" slot-scope="{ item }">
      <div class="d-flex justify-center align-center" style="height: 100%">
        <v-icon
          @click="viewItem(item.id)"
          size="20"
        >
          mdi-eye
        </v-icon>
      </div>
    </template>
  </TableView>

    <v-dialog v-model="dialog" max-width="500px">
      <table-detail :editedItem="editedItem" v-on:closeParent="close" />
    </v-dialog>
  </v-card>
</template>

<script>
import { getDate, date, showAlert } from '../../lib/helpers';
import { headers, search, editedItem } from '../../components/report/cpm-transaction/attributes';

export default {
  components: {
    TableView: () => import("../../components/@drontVue/components/Table/TableView.vue"),
    TableDetail: () =>
      import('../../components/table/CpmTransactionDetail.vue'),
    TableTopVue: () => import('../../components/table/TableTop.vue'),
    AggregatorTransactionFilter: () =>
      import('../../components/table/AggregatorTransactionFilter.vue'),
  },
  data: () => ({
    listButton: {
      buttonRestart: true,
      buttonDots: true,
      buttonSwitchCh: true,
      buttonDotsExt: [
        {
          link: 'exportExcelParent',
          show: true,
          icon: 'mdi-file-excel',
          title: 'Export to excel',
          voidStatus: true,
        },
        // {
        //   link: 'exportItemParent',
        //   show: true,
        //   icon: 'mdi-file-excel',
        //   title: 'Export to excel old',
        //   voidStatus: true,
        // },
      ],
    },
    switchCh: true,
    today: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .slice(0, 10),
    isFirstLoad: true,
    options: {},
    show: false,
    dialog: false,
    headers,
    filter: {
      trx_datetime: [],
    },
    search,
    editedItem,
    selectedRow: '',
  }),

  computed: {
    allData() {
      return this.$store.state.reportCpmTransaction.allData;
    },
    detailData() {
      return this.$store.state.reportCpmTransaction.item;
    },
    totalData() {
      return this.$store.state.reportCpmTransaction.totalData;
    },
    totalPage() {
      return this.$store.state.reportCpmTransaction.totalPage;
    },
    loading() {
      return this.$store.state.reportCpmTransaction.loading;
    },
    flashError: {
      get() {
        return this.$store.state.reportCpmTransaction.flashError;
      },
      set() {
        this.$store.commit('reportCpmTransaction/setFlashErrorMessage', '');
      },
    },
    flashErrorMessage() {
      return this.$store.state.reportCpmTransaction.flashErrorMessage;
    },
    /**
     * @returns menentukan apa env filter ch true
     */
    checkFilterCh() {
      return JSON.parse(process.env.VUE_APP_FILTER_CH);
    },
    /**
     * @returns jika env VUE_APP_FILTER_CH true, makan akan sesuai toggle. namun jika tidak, untuk default apakah ch atau bukan dengan env VUE_APP_DB_CH
     */
    checkEnvCh() {
      let filterCh = process.env.VUE_APP_DB_CH;

      if (this.checkFilterCh) {
        const filterOn = process.env.VUE_APP_FILTER_DEFAULT;
        const filterOff = filterOn === 'ch' ? 'sql' : 'ch';
        filterCh = this.switchCh ? filterOn : filterOff;
      }

      return filterCh;
    },
  },

  watch: {
    options: {
      handler() {
        if (!this.isFirstLoad) {
          this.getData();
        } else {
          this.$store.commit('reportCpmTransaction/clearData');
        }
        this.isFirstLoad = false;
      },
      deep: true,
    },
    switchCh: {
      handler() {
        this.clearSearch();
      },
    },
  },

  methods: {
    handleSwitch(val) {
      this.switchCh = val;
    },
    getDate,

    selectRow(index) {
      if (this.selectedRow !== index) {
        this.selectedRow = index;
      } else {
        this.selectedRow = '';
      }
    },

    rowClass() {
      const rowClass = 'max-width-col';
      return rowClass;
    },

    getData() {
      if (this.search.trx_datetime.length < 1) {
        this.$vuetify.goTo(0);
        showAlert(
          this.$store,
          'transaction date is required !',
          'mdi-alert',
          'red'
        );
        this.$store.commit('reportCpmTransaction/clearData');
      } else {
        const source = this.checkEnvCh;

        this.$store.commit('reportCpmTransaction/setFlashErrorMessage', '');
        const { page, itemsPerPage, sortBy, sortDesc } = this.options;
        this.$store
          .dispatch('reportCpmTransaction/getData', {
            date,
            page,
            itemsPerPage,
            sortBy,
            sortDesc,
            search: this.search,
            source,
          })
          .then(() => {
            if (this.totalPage < page) {
              if (this.totalPage == 0) {
                this.options.page = 1;
              } else {
                this.options.page = this.totalPage;
              }
            }
          });
      }
    },

    clearSearch() {
      this.search.trx_datetime = [];
      this.search.ac_id = '';
      this.search.payment_type = '';
      this.search.rrn = '';
      this.search.mid = '';
      this.search.status = '';
      this.search.bill_num = '';
      this.$nextTick(() => {
        this.$store.commit('reportCpmTransaction/clearData');
        this.$store.commit('report/clearAggregator');
        this.$store.commit('report/clearMerchant');
      });
    },

    async viewItem(itemId) {
      await this.$store
        .dispatch('reportCpmTransaction/getDetail', {
          id: itemId,
          date,
        })
        .then(() => {
          if (!this.loading && this.detailData !== null)
            this.editedIndex = itemId;
          this.editedItem = { ...this.detailData };
          this.view = true;
          this.editedIndex = -2;
          this.dialog = true;
        });
    },
    close() {
      this.view = false;
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
      });
    },

    exportExcel() {
      if (this.totalData < 1) {
        this.$vuetify.goTo(0);
        showAlert(this.$store, 'Data is empty !', 'mdi-alert', 'red');
        this.$store.commit('reportCpmTransaction/clearData');
      } else {
        const { page, itemsPerPage, sortBy, sortDesc } = this.options;
        this.$store.dispatch('exportExcel', {
          date,
          page,
          itemsPerPage,
          sortBy,
          sortDesc,
          search: this.search,
          countData: this.totalData,
          module: 'cpm-trx',
          exportUrl: 'export/generate-export-file/index',
          exportController: 'export/get-export-file',
          sourceData: this.checkEnvCh,
        });
      }
    },

    exportItem() {
      if (this.totalData < 1) {
        this.$vuetify.goTo(0);
        showAlert(this.$store, 'Data is empty !', 'mdi-alert', 'red');
        this.$store.commit('reportCpmTransaction/clearData');
      } else {
        const { page, itemsPerPage, sortBy, sortDesc } = this.options;
        this.$store.dispatch('exportList', {
          date,
          page,
          itemsPerPage,
          sortBy,
          sortDesc,
          search: this.search,
          exportUrl: 'api/v1/export/export-cpm-transaction/index',
          exportController: 'export-cpm-transaction',
        });
      }
    },
  },
};
</script>

<style>
.max-width-col td {
  white-space: nowrap;
  overflow: hidden;
  max-width: 250px;
  text-overflow: ellipsis;
}
.v-data-table .v-data-table__wrapper {
  height: 100%;
}
</style>
